/*
 * ${locale}.resources.${resourceName}.name for resource names (used for the menu and page titles)
 * ${ locale }.resources.${ resourceName }.fields.${ fieldName } for field names(used for datagrid header and form input labels)
 */

export default {
    'unauthorised-action': 'Dies ist eine nicht autorisierte Aktion',
    actions: {
        add: 'Hinzufügen',
        cancel: 'Stornieren',
        close: 'Schließen',
        create: 'Erstellen',
        configure: 'Konfigurieren',
        confirm: 'Bestätigen',
        deduct: 'Abziehen',
        delete: 'Löschen',
        duplicate: 'Duplizieren',
        edit: 'Bearbeiten',
        export: 'Exportieren',
        generated: 'Generiert',
        goBack: 'Geh Zurück',
        hide: 'Verbergen',
        import: 'Importieren',
        invite: 'Einladen',
        list: 'Liste',
        no: 'Nein',
        ok: 'Ok',
        pause: 'Pause',
        refresh: 'Aktualisierung',
        refund: 'Rückerstattung',
        reset: 'Zurücksetzen',
        resume: 'Resümee',
        retry: 'Wiederholen',
        returnTo: 'Zurück Zum',
        returnToThe: 'Zurück Zum',
        save: 'Sparen',
        search: 'Suche',
        show: 'Anzeigen',
        signIn: 'Anmelden',
        submit: 'Einreichen',
        submit_add_another: 'Speichern und weiter hinzufügen',
        terminate: 'Beenden',
        translate: 'Übersetzen',
        yes: 'Ja',
    },
    auth: {
        forgotPassword: {
            actions: {
                iRemember: 'Ich erinnere mich',
                resetPassword: 'Passwort zurücksetzen',
            },
            fields: {
                email: 'Email',
            },
            notifications: {
                success: 'Wenn wir Ihr Konto finden könnten, erhalten Sie in Kürze eine E-Mail.',
            },
            title: 'Passwort vergessen?',
        },
        login: {
            fields: {
                email: 'Email',
                password: 'Passwort',
            },
            notifications: {
                failure: 'Ungültige Anmeldeinformationen',
            },
            noCookies: {
                description: 'Cookies sind in Ihrem Browser nicht aktiviert. Bitte aktivieren Sie Cookies in Ihren Browsereinstellungen, um fortzufahren.',
                title: 'Cookies benötigt',
            },
        },
        logout: {
            description: 'Möchten Sie sich abmelden?',
            title: 'Ausloggen',
            notifications: {
                failure: 'Ihr Konto konnte nicht abgemeldet werden.',
                success: 'Ihr Konto wurde erfolgreich abgemeldet',
            },
        },
    },
    components: {
        autocomplete: {
            hinttext: 'Geben Sie ein, um die Suche zu starten',
        },
    },
    countries: {
        AD: 'Andorra',
        AE: 'Vereinigte Arabische Emirate',
        AF: 'Afghanistan',
        AG: 'Antigua und Barbuda',
        AI: 'Anguilla',
        AL: 'Albanien',
        AM: 'Armenien',
        AO: 'Angola',
        AQ: 'Antarktis',
        AR: 'Argentinien',
        AS: 'Amerikanischen Samoa-Inseln',
        AT: 'Österreich',
        AU: 'Australien',
        AW: 'Aruba',
        AX: 'Aland Islands',
        AZ: 'Aserbaidschan',
        BA: 'Bosnien und Herzegowina',
        BB: 'Barbados',
        BD: 'Bangladesch',
        BE: 'Belgien',
        BF: 'Burkina Faso',
        BG: 'Bulgarien',
        BH: 'Bahrain',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: 'Heiliger Barthelemy',
        BM: 'Bermuda',
        BN: 'Brunei',
        BO: 'Bolivien',
        BQ: 'Bonaire, St. Eustatius und Saba',
        BR: 'Brasilien',
        BS: 'Bahamas',
        BT: 'Bhutan',
        BV: 'Bouvetinsel',
        BW: 'Botswana',
        BY: 'Weißrussland',
        BZ: 'Belize',
        CA: 'Kanada',
        CC: 'Kokosinseln',
        CD: 'Demokratische Republik Kongo',
        CF: 'Zentralafrikanische Republik',
        CG: 'Republik Kongo',
        CH: 'Schweiz',
        CI: 'Elfenbeinküste',
        CK: 'Cookinseln',
        CL: 'Chile',
        CM: 'Kamerun',
        CN: 'China',
        CO: 'Kolumbien',
        CR: 'Costa Rica',
        CU: 'Kuba',
        CV: 'Kap Verde',
        CW: 'Curacao',
        CX: 'Weihnachtsinsel',
        CY: 'Zypern',
        CZ: 'Tschechische Republik',
        DE: 'Deutschland',
        DJ: 'Dschibuti',
        DK: 'Dänemark',
        DM: 'Dominica',
        DO: 'Dominikanische Republik',
        DZ: 'Algerien',
        EC: 'Ecuador',
        EE: 'Estland',
        EG: 'Ägypten',
        EH: 'Westsahara',
        ER: 'Eritrea',
        ES: 'Spanien',
        ET: 'Äthiopien',
        FI: 'Finnland',
        FJ: 'Fidschi',
        FK: 'Falkland Inseln',
        FM: 'Mikronesien',
        FO: 'Färöer Inseln',
        FR: 'Frankreich',
        GA: 'Gabun',
        GB: 'Großbritannien',
        GD: 'Grenada',
        GE: 'Georgia',
        GF: 'Französisch-Guayana',
        GG: 'Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Grönland',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadeloupe',
        GQ: 'Äquatorialguinea',
        GR: 'Griechenland',
        GS: 'Süd-Georgien und die südlichen Sandwich-Inseln',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HK: 'Hongkong',
        HM: 'Heard Island und McDonald Islands',
        HN: 'Honduras',
        HR: 'Kroatien',
        HT: 'Haiti',
        HU: 'Ungarn',
        ID: 'Indonesien',
        IE: 'Irland',
        IL: 'Israel',
        IM: 'Isle of Man',
        IN: 'Indien',
        IO: 'Britisches Territorium des Indischen Ozeans',
        IQ: 'Irak',
        IR: 'Ich rannte',
        IS: 'Island',
        IT: 'Italien',
        JE: 'Jersey',
        JM: 'Jamaika',
        JO: 'Jordan',
        JP: 'Japan',
        KE: 'Kenia',
        KG: 'Kirgisistan',
        KH: 'Kambodscha',
        KI: 'Kiribati',
        KM: 'Komoren',
        KN: 'St. Kitts und Nevis',
        KP: 'Nord Korea',
        KR: 'Südkorea',
        KW: 'Kuwait',
        KY: 'Cayman Inseln',
        KZ: 'Kasachstan',
        LA: 'Laos',
        LB: 'Libanon',
        LC: 'St. Lucia',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesotho',
        LT: 'Litauen',
        LU: 'Luxemburg',
        LV: 'Lettland',
        LY: 'Libyen',
        MA: 'Marokko',
        MC: 'Monaco',
        MD: 'Moldawien',
        ME: 'Montenegro',
        MF: 'Sankt Martin',
        MG: 'Madagaskar',
        MH: 'Marshallinseln',
        MK: 'Mazedonien',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolei',
        MO: 'Macao',
        MP: 'Nördliche Marianneninseln',
        MQ: 'Martinique',
        MR: 'Mauretanien',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Malediven',
        MW: 'Malawi',
        MX: 'Mexiko',
        MY: 'Malaysia',
        MZ: 'Mosambik',
        NA: 'Namibia',
        NC: 'Neu-Kaledonien',
        NE: 'Niger',
        NF: 'Norfolkinsel',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Niederlande',
        NO: 'Norwegen',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Neuseeland',
        OM: 'Oman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Französisch Polynesien',
        PG: 'Papua Neu-Guinea',
        PH: 'Philippinen',
        PK: 'Pakistan',
        PL: 'Polen',
        PM: 'Saint Pierre und Miquelon',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Palästinensisches Gebiet',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Wiedervereinigung',
        RO: 'Rumänien',
        RS: 'Serbien',
        RU: 'Russland',
        RW: 'Ruanda',
        SA: 'Saudi Arabien',
        SB: 'Salomon-Inseln',
        SC: 'Seychellen',
        SD: 'Sudan',
        SE: 'Schweden',
        SG: 'Singapur',
        SH: 'St. Helena',
        SI: 'Slowenien',
        SJ: 'Spitzbergen und Jan Mayen',
        SK: 'Slowakei',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Suriname',
        SS: 'Südsudan',
        ST: 'Sao Tome und Principe',
        SV: 'El Salvador',
        SX: 'Sint Maarten',
        SY: 'Syrien',
        SZ: 'Swasiland',
        TC: 'Turks- und Caicosinseln',
        TD: 'Tschad',
        TF: 'Südfranzösische Territorien',
        TG: 'Gehen',
        TH: 'Thailand',
        TJ: 'Tadschikistan',
        TK: 'Tokelau',
        TL: 'Osttimor',
        TM: 'Turkmenistan',
        TN: 'Tunesien',
        TO: 'Tonga',
        TR: 'Truthahn',
        TT: 'Trinidad und Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwan',
        TZ: 'Tansania',
        UA: 'Ukraine',
        UG: 'Uganda',
        UM: 'USA, kleinere ausgelagerte Inseln',
        US: 'Vereinigte Staaten',
        UY: 'Uruguay',
        UZ: 'Usbekistan',
        VA: 'Vatikan',
        VC: 'St. Vincent und die Grenadinen',
        VE: 'Venezuela',
        VG: 'Britische Jungferninseln',
        VI: 'US Jungferninseln',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis und Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Jemen',
        YT: 'Mayotte',
        ZA: 'Südafrika',
        ZM: 'Sambia',
        ZW: 'Zimbabwe',
    },
    elements: {
        confirm: {
            description: 'Nach dieser Aktion können Sie die Abonnementprodukte nicht mehr bearbeiten.',
            title: 'Sind Sie sicher, dass Sie dieses Abonnement bestätigen möchten?',
        },
        delete: {
            description: 'Der Gegenstand wird endgültig entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
            title: 'Möchten Sie dies wirklich löschen?',
        },
        outdatedBrowser: {
            description: 'Unser Dashboard-Tool unterstützt nicht die aktuelle Version Ihres Browsers. Für eine bessere Nutzung dieser Website aktualisieren Sie bitte Ihren Browser auf die neueste Version.',
            linkText: 'Klicken Sie hier, um herauszufinden, wie',
            title: 'Verbessern Sie Ihr Dashboard-Erlebnis!',
        },
        terminate: {
            description: 'Das Abonnement wird dauerhaft beendet.',
            title: 'Sind Sie sicher, dass Sie dieses Abonnement kündigen möchten?',
        },
    },
    export: {
        error: {
            maximum_reached: 'Unsere Exporte dürfen jedoch nicht mehr als 15.000 Buchungen enthalten. Sie können weitere Filter hinzufügen, um die Anzahl der Buchungen zu verringern, oder die ersten 15.000 Ergebnisse fortsetzen und exportieren.',
            title: 'Wir wussten, dass Sie erfolgreich sind...',
        },
        description: 'Wählen Sie aus, welche Felder in Ihrem Export angezeigt werden sollen',
        notifications: {
            empty_filters: {
                description: 'Dies erfordert einen oder mehrere angewendete Filter. Bitte wenden Sie einen oder mehrere Filter an, um einen Export durchzuführen.',
                title: 'Es fehlen Filter',
            },
        },
        title: 'Export wird vorbereitet',
        field_groups: {
            booking: 'Buchungsdetails',
            consumer: 'Verbraucher',
            customer: 'Kundendetails',
            default: 'Standard',
            financial: 'Finanzielle Details',
            product: 'Produkt',
            user_attributes: 'Benutzerattribute',
            payment_method: 'Methode der Zahlung',
        },
        fields: {
            administration_fee: 'Verwaltungsgebühr',
            amount: 'Betrag',
            arrival_date: 'Ankunftsdatum',
            booking_date: 'Buchungsdatum',
            costfree_cancellation: 'Reiserücktrittsversicherung',
            currency: 'Währung',
            customer_email: 'Kunden-eMail',
            customer_first_name: 'Vorname des Kunden',
            customer_last_name: 'Nachname des Kunden',
            customer_license_plate: 'Kundenkennzeichen',
            customer_phone: 'Kundentelefon',
            customer_remarks: 'Kundenanmerkungen',
            departure_date: 'Abreisedatum',
            discount_amount: 'Rabattbetrag',
            discount_company_name: 'Rabatt Firmenname',
            discount_owner_id: 'Rabatt Besitzer ID',
            discount_title: 'Rabattname',
            email: 'E-Mail',
            first_name: 'Vorname',
            gateway: 'Gateway',
            has_failed_invoice: 'Rechnung ist fehlgeschlagen',
            id: 'ID',
            internal_order_id: 'Auftragsnummer',
            invoiced_at: 'Fakturiert am',
            last_name: 'Nachname',
            locale: 'Sprache',
            method: 'Methode',
            number_of_persons: 'Personenzahl',
            options_price: 'Optionspreis',
            order_id: 'Auftragsnummer',
            payment_amount_paid: 'Zahlungsbetrag bezahlt',
            payment_method: 'Payment method',
            payment_method_status: 'Payment method status',
            price_membership_deduction: 'Membership deduction',
            payment_status: 'Zahlungsstatus',
            phone: 'Telefonnummer',
            price: 'Preis',
            product_address: 'Produktadresse',
            product_id: 'Produkt ID',
            product: 'Produkt',
            provider_id: 'Provider ID',
            provider_price_total: 'Anbieterpreis gesamt',
            provider_price: 'Anbieterpreis',
            provider: 'Anbieter',
            reseller_funnel: 'Reseller-Trichter',
            reseller_id: 'Reseller ID',
            reseller_price_total: 'Händlerpreis insgesamt',
            reseller_price: 'Händlerpreis',
            reseller: 'Wiederverkäufer',
            reservation_status: 'Reservierungsstatus',
            return_flight_number: 'Rückflugnummer',
            status: 'Status',
            transaction_fee: 'Transaktionsgebühr',
            yield_price: 'Ertragspreis',
        },
    },
    fields: {
        currency: 'Währung',
        dates: 'Datum',
        datetime: {
            never: 'Noch nie',
        },
        empty: 'Unbekannte',
        ends_at: 'Endet am',
        full: 'Voll',
        is_scheduled: 'Geplant',
        none: 'Keine',
        optional: '(Optional)',
        other: 'Andere',
        percentage: 'Prozentsatz',
        price: 'Preis',
        price_original: 'Ursprünglicher Preis',
        reason: 'Grund',
        size: 'Größe',
        starts_at: 'Beginnt am',
        updated: 'Aktualisiert',
        weekday: {
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Samstag',
            7: 'Sonntag',
        },
    },
    forms: {
        email: 'Muss eine E-Mail sein',
        error: {
            'location-not-found': 'Der Standort konnte nicht gefunden werden',
            'location-could-not-be-resolved': 'Der Standort konnte nicht gefunden werden',
            'the-id-format-is-invalid': 'The id format is invalid',
        },
        invalid: {
            discount_rule: 'Ungültige Rabattregel',
            email: 'Ungültige E-Mail',
            first_name: 'Ungültiger Vorname',
            general: 'Ungültige Zeichen',
            last_name: 'Ungültiger Nachname',
            phone: 'Dieses ist eine ungültige Telefonnummer',
            max_characters: 'Es darf höchstens %{max} Zeichen sein',
            url: 'Dies ist eine ungültige URL',
            match: 'The value with %{field} does not match',
        },
        localisation: {
            available: {
                title: 'Sprache hinzufügen',
            },
            origin: {
                description: 'Möchten Sie die aktuellen %{locale}-Texte in %{target} übersetzen?',
                title: 'Ins %{source} übersetzen',
            },
            update: {
                description: 'Möchten Sie die aktuellen %{locale}-Texte in %{target} übersetzen?',
                description_2: 'Die Übersetzung überschreibt die aktuellen %{target}-Texte.',
                description_3: 'Sie werden erst gespeichert, wenn Sie das Formular abschicken.',
                inactive: 'Bitte fügen Sie den Text in %{locale} ein, bevor Sie in diese Sprache übersetzen können.',
                title: 'Ins Englische übersetzen',
            },
            required: {
                description: 'Es ist obligatorisch, alle englischen Texte einzugeben, bevor Sie andere Sprachen hinzufügen können.',
                title: 'Sprache hinzufügen',
            },
        },
        no_results: 'Zu diesem Produkt wurden keine Beschreibungen hinzugefügt.',
        number: 'Muss eine Nummer sein',
        one_of_them_required: 'Bitte füllen Sie eines dieser Felder aus.',
        required: 'Erforderlich',
        submit: {
            required: '%{locale} - %{key} wird benötigt',
        },
    },
    filters: {
        add: 'Fügen Sie einen Filter hinzu',
        category: {
            advanced: 'fortgeschritten',
            basic: 'Basic',
        },
        clear_all_filters: 'Löschen sie alle filter',
        components: {
            accountId: {
                label: 'Konto',
            },
            booking: {
                label: 'Buchung',
            },
            bookingOrderId: {
                label: 'Buchungsauftragsnummer',
            },
            bookingReservationOrderId: {
                label: 'Reservierung Auftragsnummer',
            },
            cancelled: {
                label: 'Abgesagt',
            },
            cancelledAt: {
                label: 'Storniert bei',
                placeholder: 'Wählen Sie ein Datum',
            },
            categoryId: {
                label: 'Kategorie',
                placeholder: 'Wähle eine Kategorie',
            },
            companyName: {
                label: 'Name der Firma',
            },
            createdAt: {
                label: 'Hergestellt in',
                placeholder: 'Wählen Sie ein Datum',
            },
            currencies: {
                label: 'Währungen',
                placeholder: 'Wähle eine Währung',
            },
            destinationArrivalDate: {
                label: 'Ankunftsdatum',
                placeholder: 'Beginn Service (destination arrival)',
            },
            destinationDepartureDate: {
                label: 'Abreisedatum',
                placeholder: 'Ende Service (destination departure)',
            },
            email: {
                label: 'Email',
            },
            enabled: {
                choices: {
                    active: 'Nur aktiv',
                    inactive: 'Nur inaktiv',
                },
                label: 'Aktiviert',
            },
            end_date_null_or_from: {
                label: 'Enddatum von',
            },
            funnelId: {
                label: 'Kampagnen',
            },
            interval: {
                choices: {
                    day: 'Tag',
                    month: 'Monat',
                    week: 'Woche',
                    year: 'Jahr',
                },
                label: 'Interval',
            },
            invoice: {
                label: 'Rechnung',
            },
            is_rebooked: {
                choices: {
                    active: 'Nur erneut gebucht',
                    inactive: 'Nur nicht erneut gebucht',
                },
                label: 'Erneut gebucht',
            },
            is_terminated: {
                label: 'Beendet',
            },
            lastName: {
                label: 'Familienname, Nachname',
            },
            licensePlate: {
                label: 'Nummernschild',
            },
            name: {
                label: 'Name',
            },
            orderId: {
                label: 'Auftragsnummer',
            },
            paymentStatus: {
                choices: {
                    chargedback: 'Rückbuchung',
                    deferred: 'Verzögert',
                    failed: 'Gescheitert',
                    inProgress: 'In Bearbeitung',
                    refunded: 'Zurückerstattet',
                    success: 'Erfolgreich',
                    unknown: 'Unbekannt',
                },
                label: 'Status Bezahlung',
                placeholder: 'Wählen Sie Ihre Zahlung',
            },
            phone: {
                label: 'Telefonnummer',
            },
            pointOfInterestId: {
                label: 'Sehenswürdigkeit',
            },
            productId: {
                label: 'Produkt',
            },
            providerId: {
                label: 'Anbieter',
            },
            resellerId: {
                label: 'Wiederverkäufer',
            },
            reservationStatus: {
                choices: {
                    awaiting: 'Wartet',
                    canceled: 'Storniert',
                    completed: 'Erledigt',
                    error: 'Fehler',
                    pending: 'Wartet',
                    split: 'Aufteilen',
                    underReview: 'In Überprüfung',
                },
                label: 'Reservierungsstatus',
            },
            subcategoryId: {
                label: 'Unterkategorie',
                placeholder: 'Unterkategorie',
            },
            status: {
                label: 'Status',
            },
            testBooking: {
                choices: {
                    real: 'Nur echt',
                    test: 'Nur testen',
                },
                label: 'Buchungsart',
            },
            userId: {
                label: 'Nutzer',
            },
            product_membership_id: {
                label: 'Produktmitgliedschaft',
            },
            user_product_membership_pool_id: {
                label: 'Mitgliedschaftspool',
            },
            usesDiscountCodes: {
                choices: {
                    active: 'Verwenden Sie Rabattcodes',
                    inactive: 'Keine Rabattcodes',
                },
                label: 'Verwendet Rabattcodes',
            },
        },
        title: 'Filter',
        matchtype: 'Übereinstimmungstyp',
        matchtypes: {
            between: 'Zwischen',
            contains: 'Enthält',
            ends_with: 'Endet mit',
            equals: 'Gleich',
            match_all_of: 'Passen Sie alle zusammen',
            match_one_of: 'Match eins von',
            near: 'In der Nähe von',
            range: 'Innerhalb',
            starts_with: 'Beginnt mit',
        },
    },
    general: {
        data_updated: 'Daten aktualisiert',
        error: 'Etwas ist schief gelaufen, bitte versuchen Sie es später noch einmal ...',
        images: 'Bilder',
        loading: 'Wird geladen...',
        noMatches: 'Es konnte keine Übereinstimmungen gefunden werden',
    },
    impersonation: {
        actions: {
            log_in: 'Imitieren',
            log_out: 'Zurück zu Ihrem Konto',
        },
        logged_in: 'Sie sind derzeit als %{name} angemeldet',
    },
    languages: {
        dutch: 'Niederländisch',
        english: 'Englisch',
        german: 'Deutsche',
        french: 'Französisch',
        italian: 'Italienisch',
        spanish: 'Spanisch',
    },
    localisations: {
        dialog: {
            label: 'Wählen Sie eine verfügbare Sprache',
        },
    },
    dropzone: {
        label: {
            button: 'Logo hochladen',
            button_image: 'Bild hochladen',
            description_file_max: 'Max. Dateigröße: %{max} KB',
            description_max: 'Max. Höhe: %{height}px, Max. Breite: %{width}px',
            description_min: 'Min. Höhe: %{height}px, Min. Breite: %{width}px',
            format: 'Akzeptiertes Format: %{format}',
            highlight_image: 'Bild hervorheben',
            highlighted_image: 'Hervorgehobenes Bild',
            remove_highlight: 'Highlight entfernen',
            text: 'Klicken oder ziehen',
        },
    },
    menu: {
        sidebar: {
            assets: 'Assets',
            access_points: 'Zugangspunkte',
            accounts: 'Konten',
            account_administration: 'Kontoverwaltung',
            account_details: 'Kontodetails',
            account_yields: 'Nachgeben',
            all_users: 'Alle Nutzer',
            'api-keys': 'API keys',
            bookingStats: 'Statistiken',
            bookings: 'Buchungen',
            campaigns: 'Campaigns',
            content: 'Inhalt',
            dashboard: 'Dashboard',
            discounts: 'Rabatte',
            invoices: 'Rechnungen',
            legaldocuments: {
                engagement_agreement: 'Engagement-Vereinbarung',
                main: 'Juristische Dokumente',
                privacy_statement: 'Datenschutzerklärung',
                terms_conditions: 'Allgemeine Geschäftsbedingungen',
            },
            memberships: 'Mitgliedschaften',
            membership_schedules: 'Mitgliedschaftspläne',
            membership_pools: 'Mitgliedschaftspools',
            order_create: 'Buchung erstellen',
            order_create_disallowed: 'Ihr Konto ist inaktiv. Wenden Sie sich zur Reaktivierung an MOBIAN.',
            points_of_interest: 'Points of interest',
            products: 'Produkte',
            product_memberships: 'Produktmitgliedschaften',
            properties: 'Eigenschaften',
            propertygroups: 'Property groups',
            reservations: 'Reservierungen',
            settings: 'Einstellungen',
            subcategories: 'Subcategories',
            subscriptions: 'Abonnements',
            system_administration: 'Verwaltung der Systeme',
            users: 'Benutzer',
            webhooks: 'Webhooks',
        },
        topbar: {
            accounts: {
                current: 'Strom',
                modal_title: 'Ein konto auswählen',
                no_account_selected: 'Kein Konto ausgewählt',
            },
            security: 'Security',
            profile: 'Konto',
            stop_impersonation: 'Stoppen Sie den Identitätswechsel',
        },
    },
    notifications: {
        access_methods: {
            create: {
                success: 'Die Zugriffsmethode wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Die Zugriffsmethode wurde erfolgreich gelöscht',
            },
            open: {
                success: 'Das Tor wurde geöffnet',
            },
            update: {
                success: 'Die Zugriffsmethode wurde erfolgreich aktualisiert',
            },
        },
        account_yields: {
            create: {
                success: 'Die Benutzerausbeute wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Die Benutzerausbeute wurde erfolgreich entfernt',
            },
            update: {
                success: 'Die Benutzerausbeute hat sich erfolgreich geändert',
            },
        },
        accounts: {
            create: {
                success: 'Das Konto wurde erfolgreich hinzugefügt',
                search_user_limit: 'Es werden nur die ersten %{count} Ergebnisse angezeigt, bitte verfeinern Sie Ihre Suchkriterien weiter.',
            },
            update: {
                success: 'Das Konto hat sich erfolgreich geändert',
            },
        },
        'api-keys': {
            create: {
                success: 'Der API Schlüssel wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Der API Schlüssel wurde erfolgreich entfernt',
            },
            update: {
                success: 'Der API Schlüssel wurde erfolgreich geändert',
            },
        },
        bookings: {
            amend: {
                failure: 'Die Buchung wurde nicht geändert',
                success: 'Die Buchung wurde erfolgreich geändert',
            },
            refund: {
                failure: 'Die Rückerstattung war nicht erfolgreich',
                success: 'Die Rückerstattung war erfolgreich',
            },
        },
        booking: {
            cancelled: 'Die Buchung wurde erfolgreich storniert',
        },
        export: {
            failure: 'Der Export konnte nicht gesendet werden',
            orders: {
                failure: 'Der Export konnte nicht gesendet werden',
                success: 'Der Export wird gesendet, wenn er fertig ist',
            },
            success: 'Der Export wird gesendet, wenn er fertig ist',
        },
        campaigns: {
            create: {
                success: 'Die Kampagne wurde hinzugefügt',
            },
            update: {
                success: 'Die Kampagne wurde aktualisiert',
            },
            remove: {
                success: 'Die Kampagne wurde entfernt',
            },
        },
        current_account: {
            delete: {
                success: 'Der Benutzer wurde von diesem Konto entfernt',
            },
        },
        discounts: {
            create: {
                success: 'Der Rabatt wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Der Rabatt wurde erfolgreich entfernt',
            },
            update: {
                success: 'Der Rabatt hat sich erfolgreich geändert',
            },
        },
        discount_codes: {
            create: {
                success: 'Der Rabattcode wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Der Rabattcode wurde erfolgreich entfernt',
            },
            update: {
                success: 'Der Rabattcode hat sich erfolgreich geändert',
            },
        },
        invitations: {
            created: 'Die Einladung wurde erfolgreich hinzugefügt',
            deleted: 'Die Einladung wurde erfolgreich entfernt',
            accepted: 'Die Einladung wurde angenommen',
            denied: 'Die Einladung wurde abgelehnt',
        },
        item: {
            created: 'Der Artikel wurde erfolgreich zugefügt',
            updated: 'Das Produkt wurde korrekt geändert',
        },
        memberships: {
            added: 'Benutzer wurde erfolgreich zur Mitgliedschaft hinzugefügt',
            delete: {
                success: 'Benutzer wurde aus der Mitgliedschaft entfernt',
            },
        },
        orders: {
            cancelled: {
                success: 'Order cancelled',
            },
            retry: {
                success: 'Die Buchung wurde umgebucht',
            },
            suspicious: 'Suspicious activity on this booking',
            update: {
                success: 'Die Buchung wurde erfolgreich geändert',
            },
        },
        points_of_interest: {
            create: {
                success: 'Der POI wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Der POI wurde erfolgreich entfernt',
            },
            images: {
                create: {
                    success: 'Das Bild wurde erfolgreich hinzugefügt',
                },
                delete: {
                    success: 'Das Bild wurde erfolgreich entfernt',
                },
            },
            import: {
                success: 'Die POIs wurden erfolgreich hinzugefügt',
            },
            update: {
                success: 'Der POI wurde erfolgreich geändert',
            },
        },
        products: {
            create: {
                success: 'Das Produkt wurde erfolgreich hinzugefügt',
            },
            configuration: {
                administration_fee: {
                    maximum: 'Maximum',
                    maximum_placeholder: 'z.B. 1.99, 2.50',
                    minimum: 'Minimum',
                    minimum_placeholder: 'z.B. 1.99, 2.50',
                    percentage: 'Prozentsatz',
                    percentage_placeholder: 'z.B. 0.10 (10%), 0.03 (3%)',
                },
                allow_exceed_capacity_from: 'Ungültige erlaubte Überschreitung der Kapazität',
                allow_overstay: 'Ungültiger erlaubter Überzug',
                arrival_dates_blocked: 'Ungültige blockierte Ankunftsdaten',
                blocked_dates: 'Ungültige blockierte Daten',
                capacity: 'Ungültige Kapazität',
                departure_dates_blocked: 'Ungültige blockierte Ankunftsdaten',
                freeze_period: 'Ungültige Sperrfrist',
                leeway_arrival: 'Ungültiger Ankunftszeit-Spielraum',
                leeway_departure: 'Ungültiger Abfahrtszeit-Spielraum',
                maximum_advance: 'Ungültige maximale Vorlaufzeit',
                maximum_duration: 'Ungültige minimale Vorlaufzeit',
                minimum_advance: 'Ungültige minimale Vorlaufzeit',
                minimum_duration: 'Ungültige Dauer',
                number_of_persons: 'Ungültige Anzahl von Personen',
                operational_times: 'Ungültige Betriebszeit (en) nur wochentagspezifisch oder unspezifisch zulässig',
                sales_price: 'Ungültiger Verkaufspreis',
                split_percentage: 'Ungültiger geteilter Preisprozentsatz',
                terms_and_conditions: {
                    name: 'Ungültiger Name',
                    link: 'Ungültige URL',
                },
                vat_percentage: 'Ungültiger Mehrwertsteuersatz',
                voucher_include_invoice: 'Ungültiger Gutschein inklusive Rechnung',
            },
            delete: {
                success: 'Das Produkt wurde erfolgreich entfernt',
            },
            update: {
                success: 'Das Produkt wurde erfolgreich geändert',
            },
            failure: 'Produkt wurde nicht entfernt',
            images: {
                create: {
                    success: 'Das Bild wurde erfolgreich hinzugefügt',
                },
                delete: {
                    success: 'Das Bild wurde erfolgreich entfernt',
                },
            },
            localisation: {
                update: {
                    success: 'Die Texte wurden erfolgreich aktualisiert',
                },
            },
            logo: {
                create: {
                    failure: 'Beim Hochladen des Logos ist ein Fehler aufgetreten',
                    success: 'Das Logo wird hochgeladen',
                },
                delete: {
                    failure: 'Beim Löschen des Logos ist ein Fehler aufgetreten',
                    success: 'Das Logo wird gelöscht',
                },
            },
            property: {
                create: {
                    success: 'Die Eigenschaft wurde erfolgreich hinzugefügt',
                },
                delete: {
                    success: 'Die Eigenschaft wurde erfolgreich entfernt',
                },
                update: {
                    success: 'Die Eigenschaft wurde erfolgreich geändert',
                },
            },
            related: {
                create: {
                    success: 'Das Produkt wurde zugewiesen',
                },
                delete: {
                    success: 'Die Beziehung zwischen den Produkten wird gelöscht',
                },
            },
            resource: {
                available_resources: {
                    failure: 'Beim Abrufen der verfügbaren Ressourcen ist ein Fehler aufgetreten',
                },
                update: {
                    success: 'Die Produktressource wurde erfolgreich geändert',
                },
            },
        },
        profile: {
            update: {
                success: 'Das Profil wurde erfolgreich geändert',
            },
        },
        propertygroups: {
            create: {
                success: 'Die Eigenschaftsgruppe wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Die Eigenschaftsgruppe wurde erfolgreich entfernt',
            },
            update: {
                success: 'Die Eigenschaftsgruppe wurde erfolgreich geändert',
            },
        },
        properties: {
            create: {
                success: 'Die Eigenschaften wurden erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Die Eigenschaften werden erfolgreich entfernt',
            },
            update: {
                success: 'Die Eigenschaften wurden erfolgreich geändert',
            },
        },
        subcategories: {
            create: {
                success: 'Die Unterkategorie wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Die Unterkategorie wurde erfolgreich entfernt',
            },
            update: {
                success: 'Die Unterkategorie wurde erfolgreich geändert',
            },
        },
        subscriptions: {
            create: {
                success: 'Das Abonnement wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Das Abonnement wurde erfolgreich entfernt',
            },
            update: {
                success: 'Das Abonnement wurde erfolgreich geändert',
            },
            confirm: {
                success: 'Die Anmeldung wurde erfolgreich bestätigt',
            },
            terminate: {
                success: 'Das Abonnement wurde erfolgreich gekündigt',
            },
        },
        subscriptionProducts: {
            create: {
                success: 'Das Abonnementprodukt wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Das Abonnementprodukt wurde erfolgreich entfernt',
            },
        },
        users: {
            create: {
                success: 'Der Benutzer wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Der Benutzer wurde erfolgreich entfernt',
            },
            update: {
                success: 'Der Benutzer hat sich erfolgreich geändert',
            },
            confirmed: {
                success: 'Der Benutzer wurde erfolgreich bestätigt',
            },
            password: {
                failure: 'Beim Senden der Anfrage ist ein Fehler aufgetreten. Versuchen Sie es später noch einmal.',
                success: 'Der Benutzer wird per E-Mail über eine Aufforderung zum Zurücksetzen des Passworts informiert.',
            },
        },
        user_product_membership: {
            create: {
                success: 'Die Benutzer-Produktmitgliedschaft wurde hinzugefügt',
            },
            delete: {
                success: 'Die Benutzer-Produktmitgliedschaft wurde entfernt',
            },
            update: {
                success: 'Die Benutzer-Produktmitgliedschaft wurde angepasst',
            },
        },
        utilities: {
            translate: {
                create: {
                    success: 'Der Basistext wurde übersetzt.',
                },
            },
        },
        yields: {
            delete: {
                success: 'Die Ausbeute wurde erfolgreich entfernt',
            },
        },
        webhooks: {
            create: {
                success: 'Der Webhook wurde erfolgreich hinzugefügt',
            },
            delete: {
                success: 'Der Webhook wurde erfolgreich entfernt',
            },
            update: {
                success: 'Der Webhook wurde erfolgreich aktualisiert',
            },
        },
    },
    pages: {
        booking_tool: {
            not_available: {
                text: 'Es scheint, dass für dieses Konto kein Dashboard-Vergleichstool verfügbar ist, Für weitere Informationen kontaktieren Sie bitte Ihren Account Manager',
                title: 'Schade... :(',
            },
        },
        create_booking: {
            description: 'Bevor Sie die Produkte sehen können, wir bitten Sie, diese Felder auszufüllen, um die Suche genauer zu machen.',
            form: {
                errors: {
                    destination_arrival_date: 'Bitte geben Sie ein Datum ein',
                    destination_arrival_time: 'Bitte geben Sie eine Uhrzeit ein',
                    destination_departure_date: 'Bitte geben Sie ein Datum ein',
                    destination_departure_time: 'Bitte geben Sie eine Uhrzeit ein',
                    destination_google_place_id: 'Bitte geben Sie ein Ziel ein',
                    number_of_persons: 'Bitte füllen Sie die Anzahl der Personen aus',
                    one_way: 'Bitte füllen Sie den Reisetyp aus',
                    origin_google_place_id: 'Bitte geben Sie die Adresse ein, die Sie abholen möchten',
                },
                fields: {
                    destination_arrival_date: 'Wann möchten Sie reisen?',
                    destination_arrival_time: 'Abfahrtszeit',
                    destination_departure_date: 'Wann möchten Sie zurückkommen?',
                    destination_departure_time: 'Rückkehr zeit',
                    destination_google_place_id: 'Was ist dein Ziel?',
                    one_way: {
                        retour_trip: 'Retour Trip',
                        single_trip: 'Single Trip',
                    },
                    origin_google_place_id: 'Meine Adresse',
                    service: {
                        park_and_sleep: 'Parken und Übernachtenp',
                        park_and_walk: 'Parken und Wandern',
                        public_transport: 'Öffentliche Verkehrsmittel',
                        short_long_parking: 'Kurz-/Langzeitparken',
                        taxi: 'Taxi',
                        title: 'Serviceoptionen',
                        valet_parking: 'Parkservice',
                    },
                },
            },
            not_available: {
                text: 'Es scheint, dass für dieses Konto kein Dashboard-Vergleichstool verfügbar ist, Für weitere Informationen kontaktieren Sie bitte Ihren Account Manager',
                title: 'Schade... :(',
            },
            title: 'Erstellen Sie eine Buchung',
        },
        dashboard: {
            select: 'Wählen Sie Ihre Währung aus',
            widgets: {
                statistics_card: {
                    bookings: 'Buchungen',
                    current_week: 'Diese Woche',
                    last_week: 'Letzte Woche',
                    today: 'Heute',
                    week: 'Woche',
                    yesterday: 'Gestern',
                },
                statistics_graph: {
                    current_month: 'Letzte 4 Wochen',
                    previous_year: 'Letztes Jahr',
                    title: 'Buchungen',
                },
            },
        },
    },
    resources: {
        access_methods: {
            create: {
                title: 'Erstellen Sie eine Zugriffsmethode',
            },
            delete: {
                title: 'Zugriffsmethode löschen',
                description: 'Möchten Sie diese Zugriffsmethode wirklich löschen?',
            },
            edit: {
                title: 'Bearbeiten Sie diese Zugriffsmethode',
            },
            fields: {
                access_id: 'Zugriffs-ID',
                access_point_access_method_id: 'Zugriffspunkt-Zugriffsmethode-ID',
                access_point_id: 'Zugriffspunkt-ID',
                carpark_id: 'Parkplatz-ID',
                connector_id: 'Stecker-ID',
                custom_counter_id: 'Benutzerdefinierte Zähler-ID',
                depot_id: 'Depot-ID',
                direction: 'Richtung',
                door_id: 'Tür-ID',
                enabled: 'Status',
                gate_id: 'Gate-ID',
                is_allowed_for_users: 'Zugang für Benutzer erlauben',
                location_id: 'Standort-ID',
                name: 'Name',
                phone: 'Telefonnummer',
                phone_country: 'Land der Telefonnummer',
                product_id: 'Produkt ID',
                station_id: 'Stations-ID',
                subscription_id: 'Abonnement-ID',
            },
            list: {
                active: 'Aktiv',
                direction: 'Richtung',
                directions: {
                    1: 'Ein- / Aussteigen',
                    2: 'Eingeben',
                    3: 'Ausfahrt',
                },
                enabled: 'Status',
                inactive: 'Inaktiv',
            },
            no_results: 'Keine Zugriffsmethoden gefunden',
            open: 'Offenes tor',
            requesting: 'Anfordern',
            title: 'Zugriffsmethoden',
        },
        access_points: {
            actions: {
                create: {
                    title: 'Erstellen Sie einen Zugangspunkt',
                },
                edit: {
                    title: 'Bearbeiten Sie diese Zugangspunkt: %{title}',
                },
            },
            fields: {
                access_point: 'Wählen Sie einen Zugangspunkt',
                access_method: 'Wählen Sie eine Zugriffsmethode',
                product: 'Produkt',
                title: 'Titel',
                type: 'Typ',
            },
            no_results: 'Keine Zugangspunkte gefunden',
            title: 'Zugangspunkte',
            types: {
                access: 'Zugriff',
                on_site: 'Vor Ort',
            },
        },
        account_yields: {
            actions: {
                create: 'Erstellen Sie eine Benutzerausbeute',
                edit: 'Benutzerausbeute aktualisieren',
            },
            fields: {
                accountId: 'Nutzer',
                yield: 'Yield',
            },
            title: 'Yields',
        },
        accounts: {
            actions: {
                activate: 'Aktivieren',
                create: 'Konto anlegen',
                deactivate: 'Deaktivieren',
                edit: 'Konto bearbeiten',
            },
            activity: {
                activate: {
                    title: 'Das Konto wird aktiviert',
                    description: 'Wenn das Konto aktiv ist, kann sich das Konto bei unseren Dashboards und Apps anmelden und unsere Dienste nutzen.',
                },
                deactivate: {
                    title: 'Das Konto wird deaktiviert',
                    description: 'Wenn das Konto inaktiv ist, kann sich das Konto nicht mehr bei unseren Dashboards oder Apps anmelden oder unsere Dienste nutzen.',
                },
            },
            fields: {
                address: 'Adresse',
                bic: 'BIC',
                city: 'Stadt',
                contact_details: 'Kontaktangaben',
                contact_email: 'E-mail',
                contact_emergency_phone: 'Notruftelefon',
                contact_phone: 'Kontakttelefon',
                contact_whatsapp: 'Whatsapp-Nummer',
                country: 'Land',
                email: 'Email',
                iban: 'IBAN',
                is_enabled: 'Aktiv',
                last_name: 'Nachname',
                locale: 'Lokal',
                name: 'Name',
                notify_on_cancelled: 'Bei Stornierung benachrichtigen',
                notify_on_created: 'Bei Erstellung benachrichtigen',
                notify_on_modified: 'Bei Änderungen benachrichtigen',
                orders: 'Aufträge',
                owner: 'Inhaber',
                phone: 'Telefon',
                registration: 'COC-Nummer',
                role: 'Rolle',
                vat: 'VAT',
                zipcode: 'Postleitzahl',
            },
            filters: {
                active: {
                    active: 'Nur aktiv',
                    inactive: 'Nur inaktiv',
                },
            },
            forms: {
                account: 'Konto',
                account_search_user: 'Nutzer suchen',
                account_select_user: 'Nutzer wählen',
                address: 'Adresse',
                company: 'Unternehmen',
                contact: 'Kontakt',
                general: 'Allgemeines',
                notifications: 'Einstellungen für E-Mail-Benachrichtigungen',
                products: 'Zuletzt aktualisierte Produkte',
                registrations: 'Anmeldungen',
            },
            name: 'Benutzer',
            notifications: {
                inactive: 'Dieser Benutzer ist inaktiv. Klicken Sie auf den Aktivieren-Button, um den Benutzer zu reaktivieren.',
                not_confirmed: 'Dieser Benutzer hat sein Konto noch nicht bestätigt.',
            },
            products: {
                actions: {
                    list: 'Alle Produkte anzeigen (%{total})',
                },
            },
            reset_password: {
                description: 'Wenn Sie ein Passwort zurücksetzen, wird ein neues Passwort an die E-Mail-Adresse des Benutzers gesendet. Das alte Passwort kann nicht mehr verwendet werden. Derzeit angemeldete Sitzungen dieses Benutzers müssen sich auf allen Geräten mit ihrem neuen Passwort anmelden.',
                title: 'Setzen Sie das Benutzerpasswort zurück',
            },
            roles: {
                administrator: 'Administrator',
                reseller: 'Wiederverkäufer',
                provider: 'Anbieter',
            },
            select_user: {
                table: {
                    email: 'Email',
                    name: 'Name',
                },
            },
            title: 'Benutzer',
        },
        'api-keys': {
            actions: {
                create: 'Erstellen Sie einen API-Schlüssel',
                edit: 'API-Schlüssel bearbeiten',
            },
            error: {
                description: 'Die maximale Anzahl verfügbarer API-Schlüssel wurde erreicht. Sie können keine API-Schlüssel mehr erstellen. Bitte entfernen Sie eine, bevor Sie eine neue erstellen.',
                title: 'Hoppla...',
            },
            fields: {
                created_at: 'Date',
                last_used_at: 'Token',
                name: 'Name',
                token: 'Schlüssel',
            },
            modal: {
                description: 'Hier ist Ihr neuer API-Schlüssel. <strong>Dies ist der einzige Zeitpunkt, zu dem das Token angezeigt wird. Verlieren Sie es also nicht!</strong> Sie können das Token jederzeit löschen.',
                title: 'API-Schlüssel für %{name}',
            },
            title: 'API-Schlüssel',
        },
        bookings: {
            actions: {
                edit: 'Buchung: %{name} (%{id})',
            },
            amend: {
                buttons: {
                    paymentInvoice: 'Per Rechnung bezahlen',
                    paymentMethod: 'Wählen Sie die Zahlungsmethode',
                    price: 'Neuer Preis',
                },
                loading: {
                    'price-check-error': 'Bei der Suche nach einem neuen Preis ist ein Fehler aufgetreten',
                    'payment-invoice': 'Es wird versucht, per Rechnung zu zahlen',
                    'payment-link': 'Zahlungslink erstellen',
                    'payment-not-required': 'Änderung der aktualisierten Werte',
                    form: 'Neue Preise erzielen',
                    payments: 'Alle Zahlungsmethoden abrufen',
                    transactions: 'Transaktion erstellen',
                },
                messages: {
                    'amendError': 'Beim Speichern des Formulars ist ein Fehler aufgetreten.',
                    'payment-invoice': 'Zahlung ist fakturierbar. Sie können das Formular speichern.',
                    'payment-not-required': 'Zahlung ist nicht erforderlich. Sie können das Formular speichern.',
                    'payment-required': 'In der Preisdifferenz sind mögliche Transaktionskosten nicht enthalten.',
                    'price-check-error': 'Bei der Suche nach einem neuen Preis ist ein Fehler aufgetreten',
                    linkCopied: 'Der Zahlungslink wird kopiert',
                    availability: 'Dieses Produkt ist nicht länger verfügbar.',
                },
                prices: {
                    current: 'Derzeitiger Preis',
                    difference: 'Unterschied',
                    new: 'Neuer Preis',
                },
                phase: {
                    paymentLink: 'Ihr Zahlungslink für %{title} - %{method}',
                },
                title: 'Buchung ändern',
            },
            fields: {
                createdAt: 'Hergestellt in',
                customerRemarks: 'Kundenanmerkungen',
                destinationArrivalDate: 'Ankunftsdatum',
                email: 'Email',
                firstName: 'Vorname',
                fullName: 'Vollständiger Name',
                funnelId: 'Kampagne',
                lastName: 'Familienname, Nachname',
                licensePlate: 'Nummernschild',
                locale: 'Lokal',
                orderId: 'Auftragsnummer',
                phone: 'Telefon',
                price: 'Preis',
                product: 'Produkt',
                resellerId: 'Wiederverkäufer',
                status: 'status',
            },
            forms: {
                additional: 'Zusätzlich',
                general: 'Allgemeines',
            },
            refund: 'Buchung erstatten',
            title: 'Buchungen',
        },
        campaigns: {
            actions: {
                create: 'Erstellen Sie eine Kampagne',
                edit: 'Aktualisieren Sie diese Kampagne: %{title}',
            },
            fields: {
                accountId: 'Wiederverkäufer',
                id: 'ID',
                identifier: 'Kennung',
                name: 'Name',
            },
            name: 'Kampagne',
            title: 'Kampagnen',
            show: {
                api: 'API',
                catalogue: 'Katalog',
                week: 'Woche',
                last_week: 'Buchungen in den letzten Wochen',
                week_number: 'Wochennummer',
                bookings_amount: '# der Buchungen',
                tabs_title: 'Informationen zur Verwendung von Katalog / API',
                catalogue_p1: 'Sie sind noch nicht bereit für eine vollständige API-Integration, möchten aber schnell und sicher starten? Der Buchungstrichter von MOBIAN kann problemlos verwendet werden und funktioniert unmittelbar nach dem Erstellen einer Kampagne. Das einzige, was Sie in Ihrem Link mitschicken müssen, ist Ihre Kampagnen-ID. Ihre Kennung ist ein eindeutiger Token, mit dem wir die Buchung ganz einfach Ihrem Konto hinzufügen können, als hätten Sie sie über Ihre eigene Website verkauft. Wir haben unten ein Beispiel hinzugefügt.',
                catalogue_p2: 'Sie können die Kampagnen-ID zu jeder Seite hinzufügen, die der Buchungstrichter zu bieten hat. Auf diese Weise können Sie Ihren Benutzer jederzeit an einer beliebigen Stelle im Trichter starten lassen und die Erfahrung an seine Bedürfnisse anpassen.',
                catalogue_p3: 'Sobald ein Benutzer auf der Seite landet, an die Ihre Kampagne angehängt ist, erhält er einen Marker. Dieser Marker stellt sicher, dass jeder Verkauf, den diese Person während des Verkaufs tätigt, unter Ihrem Konto erfolgt. Sei vorsichtig; Wenn ein Benutzer den Buchungstrichter mit einer neuen Kampagne besucht, überschreibt dies den aktuell aktiven Marker. Die Marker haben eine Abklingzeit von 72 Stunden, nach der sie deaktiviert werden. Nach diesem Zeitraum vorgenommene Buchungen werden erst dann an Ihr Konto angehängt, wenn sie erneut einen Link mit Ihrer Kennung aufrufen.',
                api_p1: 'Nett! Sie integrieren sich in die API, möchten jedoch verschiedene Kampagnen oder Trichter definieren, über die Sie verkaufen. Sie können der Kampagne ganz einfach eine Buchung hinzufügen. Zu diesem Zweck benötigen Sie möglicherweise Ihr technisches Personal, um die Anforderungen, die Sie an unsere API senden, anzupassen. Wenn Sie eine Buchung erstellen, kommunizieren Sie bereits viele Informationen und wir fügen dem Puzzle ein weiteres Teil hinzu. In der Dokumentation finden Sie einen Parameter namens funnel_id. Für diese Stückinformationen benötigen Sie eine ID, die Sie eingeben können.',
                api_p2: 'Die Kennung für diese Kampagne lautet:',
                api_p3: 'Nachdem Buchungen mit dieser ID erstellt wurden, werden sie automatisch an diese Kampagne angehängt.',
            },
        },
        bookingStats: {
            fields: {
                AUD: 'AUD',
                CHF: 'CHF',
                EUR: 'EUR',
                GBP: 'GBP',
                NZD: 'NZD',
                SEK: 'SEK',
                USD: 'USD',
                amount: 'Menge',
                bookings: 'Buchungen',
                label: 'Datum',
                total: 'total',
            },
            name: 'Statistiken',
            title: 'Buchungsstatistik',
        },
        discount_codes: {
            actions: {
                create: 'Erstellen Sie einen Rabattcode',
                edit: 'Bearbeiten Sie diese Rabattcode: %{title}',
            },
            components: {
                expiry_date: {
                    placeholder: 'Verfallsdatum',
                },
                status: {
                    choices: {
                        unused: 'Unbenutzt',
                        used: 'Verwendet',
                    },
                },
                type: {
                    choices: {
                        multi: 'Mehrfach verwendbar',
                        single: 'Einmalige Verwendung',
                        wallet: 'Geldbörse',
                    },
                },
            },
            fields: {
                amount: 'Betrag',
                amount_used: 'Verwendeter Betrag',
                currency: 'Währung',
                expiry_date: 'Verfallsdatum',
                id: 'ID',
                is_enabled: 'Aktiv',
                last_used_at: 'Zuletzt benutzt um',
                percentage: 'Prozentsatz',
                status: 'Status',
                token: 'Token',
                type: 'Typ',
            },
            title: 'Rabatt-Codes',
        },
        discounts: {
            actions: {
                activate: 'Aktivieren',
                create: 'Erstellen Sie eine Rabatt',
                deactivate: 'Deaktivieren',
                edit: 'Aktualisieren Sie diese Rabbat: %{title}',
                list: 'Liste',
            },
            activity: {
                activate: {
                    title: 'Aktivieren',
                    description: 'Möchten Sie diesen Rabatt wirklich aktivieren?',
                },
                deactivate: {
                    title: 'Deaktivieren',
                    description: 'Möchten Sie diesen Rabatt wirklich deaktivieren?',
                },
            },
            fields: {
                accountId: 'Konto',
                amount: 'Betrag',
                apply_on_fees: 'Gebühren anwenden',
                created_at: 'Erstellt bei',
                currency: 'Währung',
                end_processing: 'Verarbeitung beenden',
                expiry_date: 'Verfallsdatum',
                id: 'ID',
                is_enabled: 'Aktiv',
                limit: 'Begrenzung',
                percentage: 'Prozentsatz',
                priority: 'Priorität',
                title: 'Titel',
                uses_discount_codes: 'Verwendet Rabatt-Codes',
            },
            forms: {
                account: 'Konto',
                discount_codes: 'Rabatt-Codes',
                general: 'Allgemein',
                manage_discount_codes: 'Kortingscodes',
            },
            operators: {
                labels: {
                    and: 'Und',
                    equal_or_greater_than: 'Gleich oder größer als',
                    equal_or_less_than: 'Gleich oder kleiner als',
                    equal: 'Ist gleich',
                    greater_than: 'Größer als',
                    less_than: 'Weniger als',
                    not_equal: 'Ist nicht gleich',
                    or: 'Oder',
                    within: 'Innerhalb',
                },
                title: 'Operator',
            },
            placeholders: {
                email_domain: 'z.B. nu.nl',
            },
            rules: {
                appliance: 'Regeln für die Anwendung',
                condition: 'Regeln für Bedingungen',
                title: 'Regeln für Anwendung und Bedingungen',
                no_results: 'Es gibt keine %{type}',
            },
            types: {
                global: 'Globale',
                regular: 'Regulär',
            },
            title: 'Rabatte',
        },
        invitations: {
            actions: {
                accept: {
                    title: 'Einladung annehmen',
                    description: 'Möchten Sie diese Einladung annehmen?',
                },
                deny: {
                    title: 'Einladung verweigern',
                    description: 'Möchten Sie diese Einladung ablehnen?',
                },
            },
            no_invitations: 'Keine Einladungen gefunden.',
            open_invitations: 'Offene Einladungen',
            request_title: 'Anfragen zur Einladung',
            sent_title: 'Gesendete Einladungen',
            title: 'Einladungen',
        },
        invoices: {
            download: 'Download Rechnung',
            export: {
                success: 'Rechnungen wurden erfolgreich exportiert.',
                title: 'Rechnungen exportieren',
                lines: {
                    title: 'Exportiere Rechnungspositionen',
                },
            },
            fields: {
                amount: 'Betrag',
                invoiced_at: 'Fakturiert am',
                status: 'Status',
            },
            show: {
                details: 'Einzelheiten',
                title: 'Rechnung anzeigen',
            },
            status: {
                charged_back: 'Rückgebucht',
                open: 'Öffnen',
                overdue: 'Überfällig',
                paid: 'Bezahlt',
                paid_manually: 'Manuell bezahlt',
                processing: 'Processing',
            },
            title: 'Rechnungen',
        },
        general: {
            fields: {
                boolean: {
                    yes: 'Ja',
                    no: 'Nein',
                },
            },
        },
        memberships: {
            actions: {
                edit: 'Bearbeiten Sie diese Mitgliedschaft: %{title}',
            },
            fields: {
                concurrency: 'Parallelität',
                purge_reservations: 'Reservierungen löschen',
                paid_by_invoice: 'Bezahlt per Rechnung',
            },
            messages: {
                created: {
                    success: 'Die Mitgliedschaft wurde erfolgreich erstellt',
                },
                deleted: {
                    success: 'Die Mitgliedschaft wurde erfolgreich gelöscht',
                },
                updated: {
                    success: 'Die Mitgliedschaft wurde erfolgreich aktualisiert',
                },
            },
        },
        membership_schedules: {
            messages: {
                created: {
                    success: 'Mitgliedschaftsplan erfolgreich erstellt',
                },
                deleted: {
                    success: 'Mitgliedschaftsplan erfolgreich gelöscht',
                },
                updated: {
                    success: 'Mitgliedschaftsplan erfolgreich aktualisiert',
                },
            },
        },
        no_account: {
            description: 'Um das Dashboard nutzen zu können, müssen Sie mit einem Partner verknüpft sein. Einer unserer Partner hat Ihnen möglicherweise bereits eine Einladung gesendet, seinem Unternehmenskonto beizutreten. Klicken Sie auf die Schaltfläche oben, um zu sehen, ob Sie offene Einladungen haben.',
            title: 'Keine Konten verfügbar',
        },
        orders: {
            actions: {
                check_new_price: 'Überprüfen Sie den neuen Preis',
                csv: 'CSV',
                export: 'Buchungen exportieren',
                export_related: 'Buchungsreservierungen exportieren',
                order_email_resent: 'Order email resent',
                resend_email: 'Email nochmal versenden',
                retry: 'Wiederholen',
            },
            amend: {
                message: {
                    availability: 'Dieses Produkt ist nicht länger verfügbar.',
                    payment: {
                        required: 'Die Preisdifferenz enthält keine potenziellen Transaktionskosten.',
                    },
                },
                payment_method: {
                    button: 'Zahlungsmethode',
                },
                payment_link: {
                    title: 'Ihr Zahlungslink für %{title}:',
                },
                price: {
                    current: 'Alter Preis',
                    new: 'Neuer Preis',
                    difference: 'Unterschied',
                },
                title: 'Änderung der Buchung',
            },
            cancel: {
                description: 'Möchten Sie diese Buchung wirklich stornieren?',
                title: 'Buchung stornieren',
            },
            edit: {
                no_longer_editable: 'Diese Information kann im System nicht mehr bearbeitet werden, bitte wenden Sie sich direkt an den Anbieter.',
            },
            fields: {
                campaigns: 'Kampagnen',
                cancelled_at: 'Storniert um',
                commission: {
                    int_yield_price: 'Reseller service yield',
                    mobian_commission_total: 'Gesamt',
                    mobian_product_commission_price: 'MOBIAN Kommission',
                    mobian_product_yield_commission_price: 'Produkt yield Kommission',
                    mobian_vat_amount: 'Kommission MwSt',
                    mobian_vat_price: 'Gesamt',
                    price_administration_fee: 'Bearbeitungsgebühr',
                    price_base: 'Basispreis',
                    price_costfree_cancellation: 'Kostenlose Stornierung',
                    price_options: 'Optionen',
                    provider_total_price: 'Zwischensumme',
                    reseller_commission_total: 'Reseller Kommission',
                    reseller_product_commission_price: 'Produkt Kommission',
                    reseller_product_price: 'Buchung gesamt',
                    reseller_product_yield_commission_price: 'Yield Kommission',
                    reseller_vat_amount: 'MwSt',
                    reseller_vat_price: 'Gesamt',
                },
                country_code: 'Ländercode',
                created_at: 'hergestellt am',
                customer_remarks: 'Kundenbemerkungen',
                destination_arrival_date: {
                    hours: 'Std',
                    label: 'Ankunftsdatum',
                    minutes: 'Min',
                },
                destination_address: 'Zielort',
                destination_departure_date: {
                    hours: 'Std',
                    label: 'Abreisetag',
                    minutes: 'Min',
                },
                drop_off_date: 'Anfangsdatum',
                email: 'Email',
                ending_at: 'Endet um',
                first_name: 'Vorname',
                flight_number: 'Flugnummer',
                full_name: 'Name',
                is_test: 'Test',
                last_name: 'Nachname',
                license_plate: 'Kennzeichen',
                locale: 'Sprache',
                location_address: 'Stadt',
                number_of_persons: 'Anzahl der Personen',
                order_id: 'Buchung',
                origin_address: 'Abholort',
                payment_amount_paid: 'Betrag bezahlt',
                payment_status: 'Zahlungsstatus',
                phone: 'Telefonnummer',
                pick_up_date: 'Abholdatum',
                price: 'Preis',
                product: 'Produkt',
                provider: 'Provider',
                reservation_status: 'Reservierungsstatus',
                return_flight_number: 'Nummer Rückflug',
                starting_at: 'Beginnt um',
                status: 'Status',
                updated_at: 'Zuletzt aktualisiert',
            },
            filters: {
                cancelled_at: {
                    label: 'Storniert um',
                    placeholder: 'Storniert um',
                },
                created_at: {
                    label: 'Erstellt am',
                    placeholder: 'Erstellt am',
                },
                currencies: {
                    label: 'Währungen',
                },
                destination_address: {
                    label: 'Rückgabestation',
                },
                destination_arrival_date: {
                    label: 'Ankunftsdatum',
                    placeholder: 'Beginn Service (destination arrival)',
                },
                destination_departure_date: {
                    label: 'Abreisedatum',
                    placeholder: 'Ende Service (destination departure)',
                },
                interval: {
                    choices: {
                        day: 'Tag',
                        month: 'Monat',
                        week: 'Woche',
                        year: 'Jahr',
                    },
                    label: 'Interval',
                },
                is_test_order: {
                    choices: {
                        only_real: 'Real',
                        only_test: 'Test',
                    },
                    label: 'Testbuchung',
                },
                last_name: 'Nachname',
                payment_status: {
                    choices: {
                        chargedback: 'Rückbuchung',
                        deferred: 'Verzögert',
                        failed: 'Gescheitert',
                        in_progress: 'In Bearbeitung',
                        refunded: 'Zurückerstattet',
                        success: 'Erfolgreich',
                        unknown: 'Unbekannt',
                    },
                    label: 'Status Bezahlung',
                },
                origin_address: {
                    label: 'Treffpunkt',
                },
                reservation_status: {
                    choices: {
                        canceled: 'Storniert',
                        completed: 'Erledigt',
                        error: 'Fehler',
                        pending: 'Wartet',
                        split: 'Aufteilen',
                        under_review: 'In Überprüfung',
                    },
                    label: 'Reservierungsstatus',
                },
            },
            information: {
                consumer_communication: 'Dieser Kunde erhält nicht automatisch eine Buchungs-E-Mail.',
                multibookings: {
                    split_from: 'This booking belongs to multi-booking ',
                    split_to: 'This booking has been split to ',
                },
                test_booking: 'Diese Buchung wird als Testauftrag erstellt.',
            },
            name: 'Buchungen',
            paymentSlip: {
                download: {
                    title: 'Download Zahlungsbeleg',
                },
                send: {
                    description: 'Der Verbraucher erhält einen Zahlungsbeleg mit jeder Aktualisierung. Möchten Sie den Zahlungsbeleg wirklich manuell senden?',
                    success: 'Zahlungsbeleg wurde erfolgreich gesendet',
                    title: 'Zahlungsbeleg Senden',
                },
                title: 'Zahlungsbeleg',
            },
            receipt: {
                administration_costs: 'Verwaltungskosten',
                administration_fees: 'Verwaltungsgebühren',
                base_price: 'Grundpreis',
                costfree_cancellation: 'Kostenlose Stornierung',
                membership_deduction: 'Mitgliedsrabatt',
                options: 'Optionen',
                price_base: 'Grundpreis',
                service_yield: 'Service-Leistung',
                split_deduction: 'Geteilte Abzüge',
                subtotal_additional: 'Zwischensumme zusätzliche Kosten',
                subtotal_base: 'Zwischensumme',
                subtotal_discounts: 'Zwischensumme Rabatte',
                total: 'Gesamt',
                transaction_costs: 'Transaktionskosten',
                transaction_fees: 'Transaktionsgebühren',
            },
            retry: {
                description: 'Are you sure you wish to retry this booking?',
                title: 'Retry Booking',
            },
            show: {
                activities: {
                    booking: {
                        empty: 'Für diese Buchung sind keine Aktivitäten protokolliert.',
                        label: 'Aktivitäten',
                        table: {
                            activity: 'Aktivität',
                            actor: 'Benutzer',
                            created_at: 'Datum',
                            property: 'Wert',
                            status: 'Status',
                            target_id: 'Kennung',
                            target_type: 'Ziel',
                        },
                    },
                },
                booking_information: 'Buchungsinformation',
                paid_on_invoice: 'Diese Buchung wird auf Rechnung bezahlt.',
                product: 'Produkt',
                reseller: 'Wiederverkäufer',
                reservation: 'ReservatReservierungion',
                reservation_details: 'Reservierungsdetails',
                travel_details: 'Reisedetails',
            },
            tabs: {
                activities: 'Aktivitäten',
                commission: 'Kommission',
                customer: 'Kunde',
                payment: 'Bezahlung',
                travel: 'Reise',
            },
            voucher: {
                download: {
                    title: 'Download Gutschein',
                },
                send: {
                    description: 'Der Verbraucher erhält für jedes Update einen Gutschein. Sind Sie sicher, dass Sie den Gutschein manuell senden möchten?',
                    success: 'Gutschein erfolgreich versendet!',
                    title: 'Gutschein Senden',
                },
                after_alteration: {
                    description: 'Möchten Sie den Kunden über die Updates informieren?',
                },
                title: 'Gutschein',
            },
        },
        password: {
            error: {
                password_current: 'La password non corrisponde alla password esistente.',
            },
            name: 'Ändern Sie Ihr Passwort',
            fields: {
                password_current: 'Derzeitiges Passwort',
                password_new: 'Neues Kennwort',
                password_confirmation: 'bestätige neues Passwort',
            },
            success: 'Das Passwort wurde erfolgreich gespeichert.',
        },
        points_of_interest: {
            actions: {
                create: 'Erstellen Sie einen neuen Point of Interest',
                edit: 'Point of Interest bearbeiten: %{title}',
                show: 'Punkt von Interesse: %{title}',
            },
            fields: {
                address: 'Adresse',
                city: 'Stadt',
                country: 'Land',
                google_place_id: 'Google Place ID',
                id: 'ID',
                is_highlighted: 'Hervorgehoben',
                latitude: 'Latitude',
                location_x: 'Ort x',
                location_y: 'Ort y',
                longitude: 'Längengrad',
                name: 'Name',
                state: 'Staat',
                street: 'Straße',
                street_number: 'Nº',
                type: 'Art des POI',
                zipcode: 'Postleitzahl',
            },
            import: {
                dropzone: {
                    description: 'Ziehen Sie Ihre CSV-Datei mit den neuen Sonderziele per Drag & Drop oder drücken Sie auf Import',
                    title: 'Laden Sie CSV hoch',
                },
                title: 'Importiere points of interests aus CSV',
            },
            promoted_products: {
                add: 'Beworbenes Produkt hinzufügen',
                no_results: 'Es gibt keine beworbenen Produkte',
                title: 'Beworbene Produkte',
            },
            title: 'Points of Interest',
            types: {
                accommodation: 'Unterkunft',
                airport: 'Flughafen',
                beach: 'Strand',
                bridge: 'Brücke',
                business_centre: 'Geschäftszentrum',
                city: 'Stadt',
                cultural: 'Kulturell',
                education: 'Ausbildung',
                event: 'Veranstaltung',
                event_center: 'Veranstaltungszentrum',
                government_building: 'Regierungsgebäude',
                hospital: 'Krankenhaus',
                library: 'Bibliothek',
                museum: 'Museum',
                neighbourhood: 'Stadtviertel',
                other: 'Andere',
                park: 'Park',
                port: 'Hafen',
                recreation: 'Erholung',
                religious_building: 'Religiöses gebäude',
                restaurant: 'Restaurant',
                shopping_centre: 'Einkaufszentrum',
                sight: 'Sehenswürdigkeit',
                station: 'Bahnhof',
            },
        },
        products: {
            actions: {
                activate: 'Aktivieren',
                create: 'Produkt erstellen',
                deactivate: 'Deaktivieren',
                edit: 'Produkt bearbeiten',
                localisation: 'Produktinhalt',
                occupancy: 'Belegung',
                resource: 'Ressource',
            },
            activity: {
                activate: {
                    title: 'Das Produkt ist aktiviert',
                    description: 'Das Produkt wird jetzt auf allen unseren Plattformen sichtbar gemacht.',
                },
                deactivate: {
                    title: 'Das Produkt ist deaktiviert',
                    description: 'Das Produkt ist nicht sichtbar und der Endbenutzer sieht das Produkt nicht mehr.',
                },
            },
            administration_fee: {
                title: 'Verwaltungsgebühr',
            },
            advancedTimes: {
                title: 'Maximale und minimale Vorlaufzeiten',
                fields: {
                    maximum_advance: 'Maximale Vorlaufzeit',
                    minimum_advance: 'Minimale Vorlaufzeit',
                },
            },
            allowed_capacity_excess: {
                title: 'Zulässige Kapazitäts',
                fields: {
                    capacity_excess: 'Übermaß an Kapazität',
                },
            },
            attribute: 'Attribut',
            availability: {
                button: 'Bestätigen',
                dialog: {
                    description: '',
                    title: 'Überprüfen Sie das Produkt',
                },
                results: {
                    arrival_dates_blocked: 'Blockierte Anreiset',
                    available_price_information: 'Preis verfügbar',
                    blocked_dates: 'Blockierte Termine',
                    capacity: 'Kapazität',
                    configuration: 'Konfiguration des Produkts',
                    consumer_price: 'Verbraucherpreis',
                    departure_dates_blocked: 'Blockierte Abflugdaten',
                    has_time_zone: 'Richtige Zeitzone',
                    is_visible: 'Produkt ist sichtbar',
                    maximum_advance: 'Max. Voraus',
                    maximum_duration: 'Max. Dauer',
                    minimum_advance: 'Meins. Voraus',
                    minimum_duration: 'Min. Dauer',
                    operational_times: 'Betriebszeiten',
                    pricing_service_price: 'Preisservice-Preis',
                    product_enabled: 'Produkt aktiv',
                    provider_enabled: 'Anbieter aktiv',
                    provider_price: 'Anbieterpreis',
                    supported_currency: 'Währung unterstützt',
                    supported_resource: 'Ressourceneinstellungen korrekt',
                    valid_price: 'Preis gültig',
                },
            },
            arrival_dates_blocked: {
                title: 'Blockierte Ankunft',
                add: 'Blockierte Ankunft hinzufügen',
                no_result: 'Es wurden keine blockierten Ankunftsdaten gefunden',
            },
            blocked_dates: {
                title: 'Blockierte Termine',
                add: 'Blockiertes Datum hinzufügen',
                no_result: 'Es wurden keine blockierten Daten gefunden',
            },
            capacity: {
                title: 'Kapazität',
            },
            configuration: {
                saved: 'Die Produktkonfiguration wurde erfolgreich gespeichert.',
            },
            count: 'Anzahl',
            departure_dates_blocked: {
                title: 'Gesperrte Abreisedaten',
                add: 'Gesperrte Daten hinzufügen',
                no_result: 'Es wurden keine gesperrten Abfahrtsdaten gefunden',
            },
            duration: {
                no_duration: 'Für dieses Produkt wurde keine maximale oder minimale Dauer gefunden.',
                fields: {
                    maximum_duration: 'Maximale Dauer',
                    minimum_duration: 'Mindestdauer',
                },
                placeholders: {
                    duration: 'z.B 10t oder 12h',
                    duration_day: 'z.B 10t',
                    duration_hour: 'z.B 12h',

                },
                response: {
                    save: 'Die Dauer Zeiten wurden erfolgreich gespeichert',
                },
            },
            edit: {
                location: 'Standort bearbeiten',
                resource: 'Ressource bearbeiten',
            },
            fields: {
                active: 'Activ',
                administration_fee: {
                    maximum: 'Maximum',
                    maximum_placeholder: 'z.B. 1.99, 2.50',
                    minimum: 'Mindest',
                    minimum_placeholder: 'z.B. 1.99, 2.50',
                    percentage: 'Prozentsatz',
                    percentage_placeholder: 'z.B. 0.10 (10%), 0.03 (3%)',
                },
                allow_overstay: 'Überzug erlauben',
                category_id: 'Category',
                city: 'Stadt',
                communicate_email_addresses: 'E-Mail-Adressen kommunizieren',
                company_id: 'Provider',
                conditionz: 'Geschäftsbedingungen',
                configuration: 'Aufbau',
                country_code: 'Ländercode',
                country: 'Land',
                date: 'Datum',
                description_de: 'Deutsche Beschreibung',
                description_en: 'Englische Beschreibung',
                description_es: 'Spanische Beschreibung',
                description_fr: 'Französische Beschreibung',
                description_it: 'Italienische Beschreibung',
                description: 'Niederländische Beschreibung',
                duration: 'Maximun und Mindestdauer',
                email_domain: 'E-Mail Domäne',
                email_from: 'Email gesendet von',
                email1: 'Email-Adresse Provider',
                email2: 'Email-Adresse Admin',
                enabled: 'Activ',
                freeze_period: 'Zeit des Gefrierens',
                from: 'Von',
                icon: 'Icon',
                id: 'Id',
                inactive: 'Inaktiv',
                internal_qr_code: 'Internal QR code',
                is_combined: 'Kombiniertes Produkt',
                is_official_facility: 'Dies ist ein offizieller Standplatz',
                is_visible: 'Sichtbar',
                key: 'Schlüssel',
                leeway: 'An- und Abreisespielraum',
                location_address: 'Anschrift',
                location_id: 'Standort Id',
                location_latitude: 'Breitengrad',
                location_longitude: 'Längengrad',
                logo: 'Logo',
                mail_de: 'Email auf Deutsch',
                mail_en: 'Email auf Englisch',
                mail_fr: 'Email auf Französisch',
                mail: 'Email auf Holländisch',
                map_image: 'Standort Abbildung',
                number_of_persons: 'Personenzahl',
                operational_times: 'Betriebszeiten',
                options: 'Optionen',
                parking_id: 'Parking Id',
                phone: 'Telefonnummer',
                point_of_interest_id: 'Point of interest',
                priority: 'Priority',
                product_id: 'Provider',
                property_id: 'Property',
                provider_id: 'Provider',
                radius: 'Radius',
                rating: 'Klasse',
                resource: {
                    id: 'Resource Id',
                    name: 'Resource Name',
                },
                service_id: 'Service',
                split_percentage: 'Geteilter Preisprozentsatz',
                street: 'Straße',
                subcategory_id: 'Subcategory',
                terms_and_conditions: {
                    title: 'Allgemeine Geschäftsbedingungen',
                    link: 'URL',
                    link_placeholder: 'URL eingeben',
                    name: 'Name',
                    name_placeholder: 'Name eingeben',
                },
                to: 'Zu',
                title: 'Titel',
                type: 'Type',
                updated_at: 'Aktualisiert am',
                value: 'Wert',
                vat_percentage: 'MWSt-Prozentsatz',
                voucher_include_invoice: 'Gutschein inklusive Rechnung',
                weekday: 'Wochentag',
                zipcode: 'Postleitzahl',
            },
            filters: {
                radius: {
                    '5': '5km',
                    '10': '10km',
                    '15': '15km',
                    '20': '20km',
                    '25': '25km',
                },
            },
            forms: {
                access_methods: 'Zugriffsmethoden',
                content: 'Inhalt',
                general: 'Allgemeines',
                location: 'Ort',
                logo: 'Logo',
                preferences: 'Präferenzen',
                properties: 'Eigenschaften',
                provider: 'Anbieter',
                related: 'verbunden',
            },
            freeze_period: {
                placeholder: 'zB. 2h',
            },
            leeway: {
                fields: {
                    leeway_arrival: 'Ankunftsspielraum',
                    leeway_departure: 'Abfahrtsspielraum',
                },
                placeholders: {
                    leeway: 'z. B. 30 (min)',
                },
            },
            logo: {
                description: 'Max 300px hoch, Max 300px breit',
            },
            name: 'Produkt',
            notifications: {
                configuration: 'Für dieses Produkt fehlen Konfigurationen. Gehen Sie auf die Konfigurationsseite, um die Produktkonfiguration anzupasse.',
                inactive: 'Dieses Produkt ist inaktiv. Klicken Sie auf die Aktivierungsschaltfläche, um das Produkt zu aktivieren.',
                product_missing_data: 'Diesem Produkt fehlen die Konfiguration und/oder die Ressourcendaten. Bitte geben Sie die Daten ein und versuchen Sie erneut, das Produkt zu aktivieren.',
                'product-missing-data-for-enable': 'Diesem Produkt fehlen die Konfiguration und/oder die Ressourcendaten.',
                resource: 'Diesem Produkt fehlt eine Ressource. Gehen Sie auf die Ressourcenseite, um die Produktressource anzupassen.',
                vat_percentage: 'Dieses Produkt hat keinen angewendeten Mehrwertsteuersatz in den Produktkonfigurationen. Gehen Sie auf die Konfigurationsseite, um den Mehrwertsteuersatz anzupassen.',
            },
            number_of_persons: {
                placeholder: 'Maximale Anzahl von Personen',
            },
            operational_times: {
                add: 'Betriebszeit hinzufügen',
                no_result: 'Bei diesem Produkt gibt es keine Betriebszeiten.',
                save: 'Betriebszeiten sparen',
                title: 'Betriebszeiten',
            },
            occupancy: {
                graph: {
                    label: {
                        capacity: 'Kapazität',
                        hour: {
                            capacity: 'Kapazität pro Stunde',
                            occupancy: 'Belegung pro Stunde',
                        },
                        occupancy: 'Belegung',
                    },
                    no_results: 'Am ausgewählten Datum werden keine Produkte gebucht.',
                    title: 'Belegung',
                },
                reservations: {
                    destination_arrival_date: {
                        no_results: 'Für das gewählte Datum wurden keine ankommenden Reservierungen gefunden.',
                        title: 'Ankommende Reservierungen (%{count})',
                    },
                    destination_departure_date: {
                        no_results: 'Für das gewählte Datum wurden keine abreisenden Reservierungen gefunden.',
                        title: 'Abgehende Reservierungen (%{count})',
                    },
                    id: {
                        no_results: 'Für das gewählte Datum wurden keine weiteren Reservierungen gefunden.',
                        title: 'Andere Reservierungen (%{count})',
                    },
                },
            },
            title: 'Produkte',
            properties: {
                no_results: 'Diesem Produkt wurden keine Eigenschaften hinzugefügt.',
            },
            related: {
                add: 'Fügen Sie ein verwandtes Produkt hinzu',
                delete: {
                    description: 'Der Gegenstand wird endgültig entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
                    title: 'Möchten Sie dies wirklich löschen?',
                },
                no_results: 'Es gibt keine verwandten Produkte',
                title: 'verbunden',
            },
            require_one_of: {
                add: 'Fügen Sie ein erforderliches verwandtes Produkt hinzu',
                no_result: 'Es gibt keine erforderlichen verwandten Produkte',
                title: 'Erfordern Sie eines von',
            },
            rules: 'Regeln',
            sales_price: {
                add: 'Fügen Sie ein Verkaufspreiseigenschaft',
                no_result: 'Es gibt keine Verkaufspreiskonfigurationen',
                title: 'Verkaufspreis',
            },
            pages: {
                location: 'Bearbeiten Sie den Speicherort: %{title}',
                resource: 'Bearbeiten Sie die Ressource: %{title}',
            },
            value: {
                add: 'Fügen Sie ein %{type}',
                label: 'Wert',
                no_result: 'Es gibt keine %{type} in dieser Konfiguration.',
                save: 'Speichern einer %{type}',
                title: 'Wert',
                types: {
                    dates: {
                        plural: 'Daten',
                        singular: 'Datum',
                    },
                    email_domain: {
                        plural: 'E-Mail Domänen',
                        singular: 'E-Mail Domäne',
                    },
                    time: {
                        plural: 'Zeiten',
                        singular: 'Zeit',
                    },
                },
            },
            communicate_email_addresses: {
                placeholder: 'Wählen Sie, ob E-Mail-Adressen kommuniziert werden sollen',
                choices: {
                    do_not_send: 'Nicht senden',
                    send: 'Senden',
                    send_masked: 'Maskiert senden',
                },
            },
            voucher_include_invoice: {
                placeholder: 'z.B. ja oder nein',
            },
        },
        product_memberships: {
            actions: {
                create: 'Erstellen Sie eine Produktmitgliedschaft',
                edit: 'Bearbeiten Sie die Produktmitgliedschaft',
            },
            create: {
                pricing: 'Wir verwenden den Standardpreis der Produktmitgliedschaft, wenn Sie das Preisfeld nicht aktualisieren.',
            },
            fields: {
                group_identifier: 'Gruppenkennung',
                membership_schedule: 'Zeitplan',
                price_ondemand: 'Preis auf Abruf',
                price_scheduled: 'Preis geplant',
                product_membership_id: 'Produktmitgliedschaft',
                supports_ondemand: 'Unterstützt On-Demand',
                supports_scheduled: 'Unterstützt geplant',
                user_product_membership_pool_id: 'Mitgliedschaftspool',
                user_vehicle_id: 'Fahrzeug',
                deferred: 'Verzögert',
                payment_method_description: 'Standardmäßig ist die Zahlungsmethode auf Rechnung eingestellt. Wenn Sie die verzögerte Zahlung verwenden möchten, aktivieren Sie das Kontrollkästchen unten.',
            },
            no_results: 'Es gibt keine Produktmitgliedschaften',
            title: 'Produktmitgliedschaften',
        },
        profile: {
            name: 'Profiel',
        },
        properties: {
            actions: {
                create: 'Erstellen Sie eine Eigenschaft',
                edit: 'Bearbeiten Sie die Eigenschaft',
                show: 'Eigentum: %{title}',
            },
            fields: {
                icon: 'Symbol',
                name: 'Name',
                priority: 'Priorität',
                property_group_id: 'Eigenschaftsgruppe',
            },
            languages: {
                label: 'Wählen Sie eine verfügbare Sprache aus',
            },
            title: 'Eigenschaften',
            validate: {
                property_group_id: 'Füllen Sie eine Eigenschaft Gruppe aus',
                'property-groups-not-available': 'Eigenschaft Gruppe ist nicht verfügbar.',
            },
        },
        propertygroups: {
            actions: {
                create: 'Erstellen Sie eine Eigenschaftsgruppe',
                edit: 'Bearbeiten Sie die Eigenschaftsgruppe: %{title}',
                show: 'Eigenschaftsgruppe: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'Name',
                properties: 'Eigenschaften',
                property: 'Eigenschaft',
            },
            languages: {
                label: 'Wählen Sie eine verfügbare Sprache aus',
            },
            name: 'Eigenschaftsgruppe',
            plural: 'Eigenschaftsgruppen',
        },
        reservations: {
            fields: {
                booking_order_id: 'Client MOBIAN ID',
                cancelled_at: 'Storniert bei',
                created_at: 'Erstellt',
                customer: 'Kunde',
                customer_remarks: 'Kundenbemerkungen',
                destination_address: 'Rückgabestation',
                destination_arrival_date: 'Ankunftsdatum',
                destination_departure_date: 'Abreisedatum',
                drop_off_date: 'Abgabedatum',
                ending_at: 'Endet um',
                flight_number: 'Flugnummer',
                full_name: 'Name',
                internal_order_id: 'Auftragsnummer',
                last_name: 'Nachname',
                license_plate: 'Nummernschild',
                number_of_persons: 'Personenzahl',
                origin_address: 'Treffpunkt',
                phone: 'Telefon',
                pick_up_date: 'Abholdatum',
                product: 'Produkt',
                remote_reference: 'Entfernte Referenz',
                return_flight_number: 'Rückflugnummer',
                starting_at: 'Beginnt um',
                subscription_id: 'Abonnement ID',
                subscription_reservation_id: 'Abonnement Reservierungs-ID',
                updated_at: 'Letzte Aktualisierung',
            },
            description: 'Do you want to open the barrier for the current reservation?',
            name: 'Reservierung',
            open_barrier: {
                modal: {
                    error: 'Ups, beim Öffnen der Schranke ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
                    force_not_allowed_for_access_method: 'Die Schranke ist für diese Zugangsmethode nicht erlaubt.',
                    session_open_barrier_requires_access_point: 'Das Öffnen der Schranke in dieser Sitzung erfordert einen Zugangspunkt.',
                    success: 'Die Schranke wurde erfolgreich geöffnet.',
                },
                title: 'Schranke öffnen',
            },
            title: 'Reservierungen',
            session: {
                asset_not_usable: {
                    description: 'Sie können es mit einem erzwungenen Stopp erneut versuchen. Dadurch wird die Sitzung immer beendet und das Asset wieder auf „verfügbar“ gesetzt, falls die Sitzung mit einem Asset gestartet wurde.',
                    title: 'Das Beenden der Sitzung ist aufgrund der folgenden Voraussetzungen fehlgeschlagen:',
                },
                button: {
                    end: 'Beenden Sie die Sitzung',
                    start: 'Starten Sie die Sitzung',
                    open_barrier: 'Schranke öffnen',
                },
                modal: {
                    button: {
                        submit: {
                            end: 'Beenden Sie die Sitzung',
                            start: 'Starten Sie die Sitzung',
                        },
                    },
                    callback: {
                        end: {
                            error: 'Hoppla, beim Beenden der Sitzung ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal',
                            success: 'Die Sitzung wurde erfolgreich beendet.',
                        },
                        start: {
                            error: 'Hoppla, beim Starten der Sitzung ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal',
                            success: 'Die Sitzung wurde erfolgreich gestartet.',
                        },
                    },
                    checkbox: 'Öffne das Tor',
                    description: {
                        end: 'Die aktuelle Reservierungssitzung hat bereits begonnen. Aktivieren Sie das Kontrollkästchen, wenn Sie das Tor öffnen oder schließen möchten.',
                        start: 'Die aktuelle Reservierungssitzung wurde noch nicht gestartet. Aktivieren Sie das Kontrollkästchen, wenn Sie das Tor öffnen oder schließen möchten.',
                    },
                    title: {
                        end: 'Beenden Sie die Sitzung',
                        start: 'Starten Sie die Sitzung',
                    },
                },
            },
            show: {
                activities: {
                    access_sessions: {
                        title: 'Zugriffssitzungen',
                        not_found: 'Für diese Reservierung wurden keine Zugriffssitzungsaktivitäten gefunden',
                    },
                },
                booking_information: 'Buchungsinformation',
                product: 'Produkt',
                reservation_details: 'Reservierungsdetails',
                reservation_price: 'Reservierungspreis',
                travel_details: 'Reisedetails',
            },
        },
        subcategories: {
            actions: {
                create: 'Erstellen Sie eine Unterkategorie',
                edit: 'Bearbeiten Sie die Unterkategorie',
                show: 'Unterkategorie: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'Name',
                category_id: 'Kategorie',
            },
            languages: {
                label: 'Wählen Sie eine verfügbare Sprache aus',
            },
            title: 'Unterkategorien',
            validate: {
                'categories-not-available': 'Es sind keine Kategorien verfügbar.',
            },
        },
        subscriptions: {
            actions: {
                create: 'Erstellen',
                edit: 'Bearbeiten',
            },
            fields: {
                account: 'Konto',
                company_name: 'Name der Firma',
                currency: 'Währung',
                email: 'Email',
                end_date: 'Enddatum',
                first_name: 'Vornamen',
                full_name: 'Vollständiger Name',
                last_name: 'Nachname',
                language: 'Sprache',
                license_plate: 'Nummernschild',
                name: 'Name',
                order_id: 'Bestell-ID',
                phone: 'Telefon',
                price: 'Preis',
                start_date: 'Startdatum',
                status: 'Status',
                terminated_at: 'Abgebrochen am',
            },
            show: {
                subscription_details: 'Abonnementdetails',
                subscription: 'Abonnement',
            },
            tooltips: {
                ok: 'Ok',
                pending: 'Abonnement: ausstehend',
                under_review: 'Abonnement: wird überprüft',
            },
            title: 'Abonnements',
        },
        subscriptionProducts: {
            create: {
                title: 'Abo-Produkt hinzufügen',
            },
            fields: {
                end_time: 'Endzeit',
                start_time: 'Startzeit',
                day: 'Tag',
                product: 'Produkt',
            },
            input: {
                day: {
                    1: 'Montag',
                    2: 'Dienstag',
                    3: 'Mittwoch',
                    4: 'Donnerstag',
                    5: 'Freitag',
                    6: 'Samstag',
                    7: 'Sonntag',
                },
            },
            no_results: 'Es wurden keine abonnementprodukte gefunden.',
            title: 'Abonnementprodukte',
        },
        users: {
            actions: {
                activate: 'Aktivieren',
                create: 'Benutzer anlegen',
                deactivate: 'Deaktivieren',
                edit: 'Benutzer bearbeiten',
                reset_password: 'Passwort zurücksetzen',
            },
            activity: {
                activate: {
                    title: 'Der Benutzer wird aktiviert',
                    description: 'Wenn der Benutzer aktiv ist, kann sich der Benutzer bei unseren Dashboards und Apps anmelden und unsere Dienste nutzen.',
                },
                deactivate: {
                    title: 'Der Benutzer wird deaktiviert',
                    description: 'Wenn der Benutzer inaktiv ist, kann sich der Benutzer nicht mehr bei unseren Dashboards oder Apps anmelden oder unsere Dienste nutzen.',
                },
            },
            delete: {
                warnings: {
                    'user-has-active-memberships': 'Für diesen Benutzer existieren aktive Mitgliedschaften.',
                    'user-has-active-subscriptions': 'Für diesen Benutzer existieren aktive Abonnements.',
                    'user-has-future-bookings': 'Für diesen Benutzer existieren zukünftige Buchungen.',
                    'user-has-invoicable-bookings': 'Für diesen Benutzer existieren abrechenbare Buchungen.',
                    'user-has-open-invoices': 'Für diesen Benutzer existieren offene Rechnungen.',
                    'user-has-overdue-invoices': 'Für diesen Benutzer existieren überfällige Rechnungen.',
                    'user-has-recent-recurring-payment-activity': 'Für diesen Benutzer existiert eine kürzliche wiederkehrende Zahlungsaktivität.',
                    'user-has-wallet-funds': 'Für diesen Benutzer sind Wallet-Guthaben verfügbar.',
                },
            },
            fields: {
                active: 'Aktiv',
                address: 'Adresse',
                bic: 'BIC',
                city: 'Stadt',
                company_email: 'Firmen-E-Mail',
                company_name: 'Name der Firma',
                company_registration: 'COC-Nummer',
                company_vat: 'Umsatzsteuer-Identifikationsnummer',
                contract: 'Vertrag',
                country: 'Land',
                email: 'Email',
                external_yield: 'Externer Ertrag',
                firstname: 'Vorname',
                iban: 'IBAN',
                lastname: 'Nachname',
                locale: 'Lokal',
                logo: 'Logo',
                membership_id: 'Mitgliedschaft',
                name: 'Name',
                orders: 'Aufträge',
                phonenumber: 'Telefon',
                product_commission_reseller: 'Reseller-Produktprovision',
                provider_id: 'Anbieter',
                reseller_id: 'Wiederverkäufer',
                role: 'Rolle',
                title: 'Titel',
                url: 'URL',
                user_id: 'Wiederverkäufer',
                username: 'Nutzername',
                vat: 'VAT',
                yield_commission: 'Ertragskommission',
                zipcode: 'Postleitzahl',
            },
            filters: {
                active: {
                    active: 'Nur aktiv',
                    inactive: 'Nur inaktiv',
                },
            },
            forms: {
                account: 'Konto',
                address: 'Adresse',
                company: 'Unternehmen',
                contact: 'Kontakt',
                general: 'Allgemeines',
                products: 'Zuletzt aktualisierte Produkte',
                registrations: 'Anmeldungen',
            },
            memberships: {
                create: 'Benutzermitgliedschaft erstellen',
                edit: 'Benutzermitgliedschaft bearbeiten (%{name})',
                no_results: 'Es sind keine Mitgliedschaften mit diesem Benutzer verknüpft',
                pricing: 'Preisgestaltung',
            },
            name: 'Benutzer',
            no_results: 'Es wurden keine Benutzer gefunden.',
            not_found: 'Es wurde kein Benutzer gefunden.',
            notifications: {
                inactive: 'Dieser Benutzer ist inaktiv. Klicken Sie auf den Aktivieren-Button, um den Benutzer zu reaktivieren.',
                not_confirmed: 'Dieser Benutzer hat sein Konto noch nicht bestätigt.',
            },
            products: {
                actions: {
                    list: 'Alle Produkte anzeigen (%{total})',
                },
            },
            // User-product-memberships create and edit
            product_memberships: {
                actions: {
                    create: 'Erstelle eine Benutzer-Produktmitgliedschaft',
                    edit: 'Bearbeite Benutzer-Produktmitgliedschaft',
                },
            },
            title: 'Benutzer',
            reset_password: {
                description: 'Wenn Sie ein Passwort zurücksetzen, wird ein neues Passwort an die E-Mail-Adresse des Benutzers gesendet. Das alte Passwort kann nicht mehr verwendet werden. Derzeit angemeldete Sitzungen dieses Benutzers müssen sich auf allen Geräten mit ihrem neuen Passwort anmelden.',
                title: 'Setzen Sie das Benutzerpasswort zurück',
            },
            roles: {
                reseller: 'Wiederverkäufer',
                provider: 'Anbieter',
            },
        },
        wallets: {
            fields: {
                amount: 'Betrag',
                balance: 'Stand',
                reason: 'Grund',
                type: 'Type',
            },
            no_results: 'Es wurden keine Geldbörsen gefunden.',
            title: 'Geldbörsen',
            topup: {
                notifications: {
                    success: {
                        decrease: 'Das Benutzerportemonnaie wurde erfolgreich reduziert.',
                        increase: 'Das Benutzer-Wallet wurde erfolgreich erhöht.',
                    },
                },
                label: 'Aufladen',
                title: 'Geldbörse aufladen',
            },
        },
        webhooks: {
            actions: {
                create: 'Erstellen Sie einen Webhook',
                edit: 'Webhook Bearbeiten: %{title}',
            },
            fields: {
                action_booking_cancelled: 'Aktion Buchung Abgebrochen',
                action_booking_created: 'Aktion Buchung Erstellt',
                action_booking_initialised: 'Aktion Buchung Initialisiert.',
                action_booking_modified: 'Aktion Buchung Geändert',
                action_booking_under_review: 'Aktion Buchung Im Bericht',
                action_reservation_cancelled: 'Aktion Reservierung Abgebrochen',
                action_reservation_created: 'Aktion Reservierung Erstellt',
                action_reservation_modified: 'Aktion Reservierung Geändert',
                is_active: 'Aktiv',
                name: 'Name',
                url: 'url',
            },
            forms: {
                actions: 'Aktionen',
                general: 'Allgemeines',
            },
            title: 'Webhooks',
        },
    },
    page: {
        page_not_found: {
            title: 'Seite nicht gefunden',
            description: 'Die gesuchte Seite kann nicht gefunden werden.',
        },
        resource_not_found: {
            description: 'Wir konnten die gesuchte Ressource nicht finden.',
            title: 'Ressource nicht gefunden',
        },
        not_authorised: {
            title: 'Hoppla..',
            description: 'Sie sind anscheinend nicht berechtigt, diese Seite zu sehen.',
        },
    },
    release: {
        list: {
            description: 'In dieser Version haben wir die Grafiken für die Listenseiten aktualisiert. Wir haben die Schaltfläche "Anzeigen" entfernt und es möglich gemacht, den Mauszeiger über die Zeile zu bewegen und darauf zu klicken, um zur Detailseite für dieses bestimmte Element weitergeleitet zu werden.',
            title: 'Kleines Update zu unseren Übersichtsseiten',
        },
    },
    signUp: {
        errors: {
            passowrd_chars: 'Das Passwort muss mindestens 6 Zeichen enthalten',
            same_email: 'E-Mails müssen gleich sein',
            same_password: 'Passwörter müssen gleich sein',
        },
        fields: {
            confirm_email: 'E-Mail bestätigen',
            confirm_password: 'Passwort bestätigen',
        },
        no_account: 'Ich habe kein Konto',
        title: 'Registrieren',
        success: 'Benutzer wurde erfolgreich registriert',
    },
};



// WEBPACK FOOTER //
// ./src/i18n/de.js